let globalZIndexCounter = 50;

export function getNextZIndex(): number {
  return ++globalZIndexCounter;
}

export function initZIndexCounter(value: number): void {
  if (value > globalZIndexCounter) {
    globalZIndexCounter = value;
  }
}
